import React, { Component } from 'react';
import {Divider, Container, Card, Image} from 'semantic-ui-react';

class Woodwork extends Component {

  render() {
    return (
      <div>
      <Divider hidden horizontal />
      <Divider hidden horizontal />
      <Container>
        <Card.Group>

        <Card>
         <Image src='http://tlgraham.com/kayak.JPG' />
         <Card.Content>
           <Card.Header>Kayak Restoration</Card.Header>
           <Card.Meta>2017</Card.Meta>
           <Card.Description>The Kayak required a wooden patch and a fresh coat of polyurethane.</Card.Description>
         </Card.Content>
        </Card>
        <Card>
         <Image src='http://tlgraham.com/toolbox.JPG' />
         <Card.Content>
           <Card.Header>Toolbox</Card.Header>
           <Card.Meta>2017</Card.Meta>
           <Card.Description>Along with storing my tools, I got to practice dovetail joints.</Card.Description>
         </Card.Content>

        </Card>
        <Card>
         <Image src='http://tlgraham.com/chair.JPG' />
         <Card.Content>
           <Card.Header>Adirondack Chair</Card.Header>
           <Card.Meta>2017</Card.Meta>
           <Card.Description>What was once 3 1x12x8 cedar boards became an accomodator of sun basking.</Card.Description>
         </Card.Content>
        </Card>
        </Card.Group>
      </Container>
      </div>
    );
  }

}

export default Woodwork;



// WEBPACK FOOTER //
// ./src/Content/Pages/Woodwork.js